import { useSecurityContext } from '../context/SecurityContext';

export default (): { headers: object } => {
  const { accessToken, organizationId } = useSecurityContext();
  const headers = {
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...(organizationId && { OrganizationId: encodeURIComponent(organizationId) }),
  };
  return { headers };
};
